module.exports = __webpack_public_path__ + "img/icon4.cc78d9a2.png";